import React from 'react';
import SelectContext from '@/pages/home/components/NavHeader/sreachContext/index';
import { Layout } from 'tea-component';
const { Content } = Layout;

export default (props: any) => {
  return (
    <>
      <Content className="layout-search">
        <SelectContext />
      </Content>
    </>
  );
};
